module.exports = "/_next/static/images/df66c1276fa8945b5efce7d9a5625219-pj-man-in-denim-jacket@xs.jpg";